import './style.css'
import ReactDOM from 'react-dom/client'
import Navbar from './components/elements/navbar/Navbar'
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './components/elements/routes/AppRoutes';
import TypingAnimation from './components/elements/animation/TypingAnimation';
import backgroundImage from '/image/backgroundImage1.jpg';
import '/style.css';

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(<>

  <BrowserRouter>
    <Navbar />
    <AppRoutes />
  </BrowserRouter>


</>
)